export const PRODUCT_DETAIL_PAGE_MAX_WIDTH = 1520;
